import { IEnvironment } from '@shared/interfaces/environment';

//  for specific environment info - look at assets folder
//  json files are used so environment can be loaded at runtime and not compile time

export const environment: IEnvironment = {
    version: '2.2'
};
